import React, { Component } from "react";
import { connect } from "react-redux";
import { Translate } from "react-redux-i18n";

import "../../../styles/components/map/mapboxExtensions/Suggestions.scss";
import google from "../../../styles/images/powered_by_google.png";

class Suggestions extends Component {
  render() {
    return (
      <div id="suggestions">
        {this.props.suggestions.map((s, k) => {
          let title = '';
          let address = '';

          if(this.props.keyTab === 'location') {
            const split= s.description?.split(",");
            title = split?.shift();
            address = split?.join(",");
          } else {
            title = s.name;
            address = `${s.address?.street}, ${s.address?.city}`;
          }

          return (
            <div key={"suggestion" + k}>
              <div
                className={"suggestion " + (this.props.selectedSuggestion === k ? "hovered" : "")}
                onKeyDown={e =>
                  e.key === "Enter" &&
                  this.props.query(e, `${title},${address}`, this.props.country, this.props.keyTab)
                }
                onClick={e => (
                  this.props.query(e, `${title},${address}`, this.props.country, this.props.keyTab),
                  this.props.keyTab === 'chargingStations' && (
                    this.props.openChargerDetail(s._id, s.chargerType)
                  )
                )}
              >
                <p className="title">{title}</p>
                <p className="address">{address}</p>
              </div>
              {k + 1 !== this.props.suggestions.length && <hr className="splitter" />}
            </div>
          );
        })}
        {this.props.suggestions.length === 0 && (
          <div className="no-suggestions">
            <Translate value="mapboxExtensions_noSuggestions" />
          </div>
        )}
        <img src={google} alt="" />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  country: state.account.accountData.country,
});

export default connect(mapStateToProps, null)(Suggestions);
